<template>
   <CRUDList
      ref="crudList"
      noResultOverride="No comments found"
      :canAdd="false"
      :canEdit="false"
      :canSave="false"
      :showSelect="false"
      :displayTopPagination="false"
      :hideDefaultFooter="true"
      :enableFixedHeaders="true"
      :disableKeyboardFunc="false"
      :headers="headers"
      :selectedItems="selectedItems"
      :baseCrudKey="baseCrudKey"
      :defaultSortBy="defaultSortBy"
      tableWrapperDynamicClassname='taxroll-table-wrapper-two'
      tableDynamicHeight='100'
      :variableToChangeRowBgColor="[{ varName: 'isItCategorySeven', varCol: '#82B1FF' }]"
      @emitSelectedItem="emitSelectedItem"
    >
    </CRUDList>
</template>
<script>
import {
  mapMutations, mapState,
} from 'vuex';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import { CommentsHeader } from '../../TaxInquiryUtils/TableHeaders.utils';
import '../../../../../assets/style.css';

export default {
  name: 'TaxRollComments',
  components: {
    CRUDList,
  },
  data() {
    return {
      baseCrudKey: 'taxRollComments',
      headers: CommentsHeader,
    };
  },
  destroyed() {
  },
  computed: {
    ...mapState({
      StoreSelItems: (state) => state.tax.taxFee.slectedComments,
    }),
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setComments(value);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'name',
          direction: 'desc',
        },
      ];
    },
  },
  methods: {
    ...mapMutations('tax/taxFee', [
      'setComments',
    ]),
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
  },
};
</script>
